import './PerformancePage.css';
import React from 'react';

import {
  useAppDispatch,
  useAppSelector,
} from 'app/hooks';
import {
  getActiveSubjects,
  getPerformanceData,
  selectPerformance,
} from 'features/performance/performanceSlice';
import { useEffect, useState } from 'react';
import SelectOption from '@module/QuestionFilter/SelectOption';
interface DataItem {
  chapter_id: string;
  chapter_name: string;
  sequence_no: string;
  total_questions: string;
  category_id: string;
  category_name: string;
  category_question_count: string;
  fastrack_question_count: string;
  doubt_count: string;
  done_count: string;
  undone_count: string;
  ldr_count: string;
  test_count: string;
}
interface Totals {
  [key: string]: number;
}

const PerformancePage = () => {
  const dispatch = useAppDispatch();
  const [selectedSubject, setSelectedSubject] = useState("");
  const [uniqueCategories, setUniqueCategories]: any = useState([])
  const [totalCounts, setTotalCounts]: any = useState(null)
  const [performanceGroupedData, setPerformanceGroupedData]: any = useState(null)
  const {
    subjects,
    performanceData,
    pending,
  } = useAppSelector(selectPerformance);


  useEffect(() => {
    dispatch(getActiveSubjects())
  }, [])

  const getPerformance = (subjectId: string) => {
    setSelectedSubject(subjectId)
    dispatch(getPerformanceData({ subject_id: subjectId }));
  }

  const calculateTotalCounts = (groupedData: any,unique_categories: any) => {
    let obj: any = {};
    let data = JSON.parse(JSON.stringify(groupedData))
    Object.values(data).map((chapterData: any, index) => {
      if (index === 0) {
        obj = chapterData;
      } else {
        obj.total_questions = parseInt(obj.total_questions) + parseInt(chapterData.total_questions)
        unique_categories.map((cat: any) => {
          let count = chapterData.categories[cat.category_id]?.category_question_count || 0;
          obj.categories[cat.category_id].category_question_count = parseInt(obj.categories[cat.category_id].category_question_count) + parseInt(count)
        })
        obj.fastrack_question_count = parseInt(obj.fastrack_question_count) + parseInt(chapterData.fastrack_question_count)
        obj.doubt_count = parseInt(obj.doubt_count) + parseInt(chapterData.doubt_count)
        obj.done_count = parseInt(obj.done_count) + parseInt(chapterData.done_count)
        obj.undone_count = parseInt(obj.undone_count) + parseInt(chapterData.undone_count)
        obj.ldr_count = parseInt(obj.ldr_count) + parseInt(chapterData.ldr_count)
        obj.test_count = parseInt(obj.test_count) + parseInt(chapterData.test_count)
      }
    })
    return obj;
  }

  const getUniqueCategory = () => {
    const unique_categories = Array.from(
      new Map(performanceData.map((item: any) => [item.category_id, { category_id: item.category_id, category_name: item.category_name }]))
        .values()
    ).sort((a: any, b: any) => a.category_name.localeCompare(b.category_name));
    return unique_categories;
  }
  useEffect(() => {

    const unique_categories = getUniqueCategory();
    setUniqueCategories(unique_categories)

    // Group by chapter_name
    const groupedData = performanceData.reduce((acc:any, curr:any) => {
      // Initialize chapter if not already present
      if (!acc[curr.chapter_name]) {
        acc[curr.chapter_name] = {
          chapter_name: curr.chapter_name,
          categories: {},
          total_questions: 0,
          fastrack_question_count: 0,
          doubt_count: 0,
          done_count: 0,
          undone_count: 0,
          ldr_count: 0,
          test_count: 0
        };

        // Add all unique categories with default `category_question_count` 0
        unique_categories.forEach((category: any) => {
          acc[curr.chapter_name].categories[category.category_id] = {
            category_name: category.category_name,
            category_question_count: 0
          };
        });
      }
    
      acc[curr.chapter_name].categories[curr.category_id].category_question_count += parseInt(curr.category_question_count);
      acc[curr.chapter_name].total_questions += parseInt(curr.total_questions);
      acc[curr.chapter_name].fastrack_question_count += parseInt(curr.fastrack_question_count);
      acc[curr.chapter_name].doubt_count += parseInt(curr.doubt_count);
      acc[curr.chapter_name].done_count += parseInt(curr.done_count);
      acc[curr.chapter_name].undone_count += parseInt(curr.undone_count);
      acc[curr.chapter_name].ldr_count += parseInt(curr.ldr_count);
      acc[curr.chapter_name].test_count += parseInt(curr.test_count);
  
      return acc;
    }, {});
    setPerformanceGroupedData(groupedData)
    let totals = calculateTotalCounts(groupedData, unique_categories)
    setTotalCounts(totals);
  }, [performanceData])

  

  const PerformanceTable = () => {
    const rows = performanceGroupedData && Object.values(performanceGroupedData).map((chapterData: any, index) => {
      return (
        <React.Fragment key={index}>
          <tr>
            <td className='text-left'>{chapterData.chapter_name}</td>
            <td>{chapterData.total_questions}</td>
            {getUniqueCategory().map((cat: any) => <td key={cat.category_id}>{chapterData.categories[cat.category_id]?.category_question_count || 0}</td>)}

            <td>{chapterData.fastrack_question_count}</td>
            <td>{chapterData.doubt_count}</td>
            <td>{chapterData.done_count}</td>
            <td>{chapterData.undone_count}</td>
            <td>{chapterData.ldr_count}</td>
            <td>{chapterData.test_count}</td>
          </tr>
        </React.Fragment>
      );
    });
    return (
      <table className="table table-bordered performance-table">
        <thead>
          <tr className="header-yellow">
            <th colSpan={11} className="header-yellow">Total Questions</th>
          </tr>
          <tr>
            <th className="header-blue"></th>
            <th className="header-orange"></th>
            <th colSpan={uniqueCategories.length + 1} className="header-green">Category</th>
            <th colSpan={5} className="header-pink">Your Own Marked</th>
          </tr>
          <tr>
            <th className="header-blue text-left">Chapters List</th>
            <th className="header-orange ">Total Qs</th>
            {uniqueCategories.map((cat: any) => <th key={cat.category_id}>{cat.category_name}</th>)}
            <th>Fast Track Qs</th>
            <th>Doubt</th>
            <th>Done</th>
            <th>UnDone</th>
            <th>LDR</th>
            <th>Test</th>
          </tr>
        </thead>
        <tbody>
          {rows && rows.length > 0 ? rows : <tr>
            <td colSpan={11}>Please select subject</td>
          </tr>}
          {totalCounts && <tr className='border-top-1 font-bold'>
            <td>Total</td>
            <td>{totalCounts.total_questions}</td>
            {uniqueCategories.map((cat: any) => <td key={cat.category_id}>{totalCounts.categories[cat.category_id]?.category_question_count || 0}</td>)}
            <td>{totalCounts.fastrack_question_count}</td>
            <td>{totalCounts.doubt_count}</td>
            <td>{totalCounts.done_count}</td>
            <td>{totalCounts.undone_count}</td>
            <td>{totalCounts.ldr_count}</td>
            <td>{totalCounts.test_count}</td>
          </tr>}
        </tbody>
      </table>
    );
  };

  return (
    <>
      <div className="row notification-container p-3 h-100 overflow-auto">

        <div className='row pb-4'>
          <div className="col-4 text-white d-flex">
            <h3 className="pb-2">Your Performance Tracker</h3>
          </div>
          <div className='col-md-8'>
            <div style={{ width: '65%' }}>
              <SelectOption
                placeholder="Select Subject"
                selected={selectedSubject}
                data={subjects}
                value={'subject_id'}
                lable={'subject_name'}
                onOptionChange={getPerformance}
              />
            </div>

          </div>
        </div>
        {PerformanceTable()}
      </div>
    </>
  )
};

export default PerformancePage;
